import { catchError } from 'rxjs/operators';

import { throwError as observableThrowError, Observable } from 'rxjs';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { NotificationsService } from 'angular2-notifications';
import { AuthenticationService } from './authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '@environment';
import { HelperService } from '@sb-tools/typescript/services/helper.service';

@Injectable()
export class Interceptor implements HttpInterceptor {
    private token: string;

    constructor(
        private notificationsService: NotificationsService,
        private authenticationService: AuthenticationService,
        private translateService: TranslateService,
    ) {
        this.token =
            HelperService.getParameterByName('r', true) || this.authenticationService.getAuthenticationData().token;
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const clonedRequest = req.clone({
            headers: req.headers
                .set('Content-Type', 'application/json')
                .set('X-Token', this.token)
                .set('Version', environment.apiVersion),
        });

        // Pass the cloned request instead of the original request to the next handle
        return next.handle(clonedRequest).pipe(
            catchError((response) => {
                let message;
                if (response.status === 401) {
                    return observableThrowError(response);
                } else {
                    if (response.error) {
                        message = response.error && response.error.message ? response.error.message : response.error;
                        if (message.toLowerCase().indexOf('timeout') >= 0) {
                            message = this.translateService.instant(
                                'Oops... your action was not completed due to a slow Internet connection. Please wait for a few seconds and try again.',
                            );
                        }
                    } else {
                        message = this.translateService.instant(
                            'Oops... Something went wrong, please try again or reload this page',
                        );
                    }
                    this.notificationsService.error(this.translateService.instant('Error!'), message);

                    return observableThrowError(response);
                }
            }),
        );
    }
}
